import React, { useCallback } from 'react';
import { useDeleteOneAutomation } from 'pages/Automations/hooks';
import { Modal, ModalBody, ModalFooterButtons, ModalHeader, ModalCloseButton } from '@televet/kibble-ui';
import { AutomationsListItemFragment } from 'shared/types/graphql';

export type AutomationToDelete = Pick<AutomationsListItemFragment, 'id' | 'name'>;

interface DeleteAutomationModalProps {
  automation: AutomationToDelete | null | undefined;
  isOpen: boolean;
  onClose: () => void;
}

export const DeleteAutomationModal = ({ automation, isOpen, onClose }: DeleteAutomationModalProps): JSX.Element => {
  const { isDeletingAutomation, handleDeleteAutomation } = useDeleteOneAutomation();

  const handleConfirmButtonClick = useCallback(async (): Promise<void> => {
    if (automation?.id) {
      await handleDeleteAutomation(automation?.id);
      onClose();
    }
  }, [automation?.id, handleDeleteAutomation, onClose]);

  return (
    <Modal size="md" onClose={onClose} isOpen={isOpen}>
      <ModalHeader>Delete Automation</ModalHeader>
      <ModalCloseButton />
      <ModalBody>
        Are you sure you want to delete {automation?.name || 'this automation'}? This action cannot be undone.
      </ModalBody>
      <ModalFooterButtons
        isLoading={isDeletingAutomation}
        isDestructive={true}
        onSubmit={handleConfirmButtonClick}
        submitText="Delete"
      />
    </Modal>
  );
};
